'use client';

import React from 'react';
import { ViewCanvas } from './components/ViewCanvas';
import { ViewSVG } from './components/ViewSVG/ViewSVG';
import {
  MapCanvasProvider,
  MapCanvasProviderProps
} from './components/map/contexts/MapCanvasContext';

export interface MapViewProps
  extends Pick<
    MapCanvasProviderProps,
    | 'isPrivacyMode'
    | 'authenticatedUser'
    | 'highlightResource'
    | 'initialPosition'
    | 'interactiveZones'
    | 'value'
  > {
  miniMapWidth?: number;
  miniMapHeight?: number;
  useSVG?: boolean;
  style?: React.SVGProps<SVGSVGElement>['style'];
}

export const MapView = React.forwardRef<SVGSVGElement | null, MapViewProps>(
  (props, ref) => {
    const {
      value,
      initialPosition,
      interactiveZones,
      highlightResource,
      miniMapHeight,
      miniMapWidth,
      useSVG = false,
      style
    } = props;
    return (
      <MapCanvasProvider
        value={value}
        initialPosition={initialPosition}
        interactiveZones={interactiveZones}
        highlightResource={highlightResource}
        isViewMode
      >
        {useSVG ? (
          <ViewSVG ref={ref} style={style} />
        ) : (
          <ViewCanvas
            miniMapWidth={miniMapWidth}
            miniMapHeight={miniMapHeight}
          />
        )}
      </MapCanvasProvider>
    );
  }
);
